import { comluxgroup } from '@luxuryescapes/contract-data-event-schemas'
import getMerchandiseShipping from 'api/merchandise/getMerchandiseShipping'
import sanitizeItemContextMetadata from 'analytics/snowplow/eventContexts/item/sanitizeItemContextMetadata'

async function getMerchandiseShippingCheckoutItem(state: App.State, item: App.Checkout.MerchandiseShippingItem, isMultiCart?: boolean) {
  const { variantId, shippingProfileId } = item

  const stateMerchandiseShipping = state.merchandise.merchandiseShipping[variantId] as App.MerchandiseShipping | undefined
  const price = stateMerchandiseShipping
    ? stateMerchandiseShipping.price
    : (await getMerchandiseShipping([variantId])).reduce((total, ship) => total + (ship.price ?? 0), 0)

  return comluxgroup.createItem_1_1_1({
    offerId: shippingProfileId ?? 'Shipping',
    categoryId: 'shop',
    productId: 'merchandise_shipping',
    offerLeadPrice: price,
    price: price,
    currency: state.geo.currentCurrency,
    metadata: sanitizeItemContextMetadata({
      isMultiCart,
    }),
  })
}

export default getMerchandiseShippingCheckoutItem
